import { Card, CardContent } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface PainPointCardProps {
  icon: LucideIcon;
  title: string;
  stat: string;
  description: string;
}

const PainPointCard = ({ icon: Icon, title, stat, description }: PainPointCardProps) => {
  return (
    <Card className="border-destructive/20 bg-destructive/5 hover:border-destructive/40 transition-all duration-300">
      <CardContent className="p-6">
        <div className="flex items-start gap-4">
          <div className="p-3 bg-destructive/10 rounded-lg">
            <Icon className="h-6 w-6 text-destructive" />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-lg mb-1">{title}</h3>
            <p className="text-sm text-destructive font-medium mb-2">{stat}</p>
            <p className="text-sm text-muted-foreground">{description}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PainPointCard;
